import PropTypes from "prop-types";

function Input({ id, label, type = "text", register, error, required, ...props }) {
  return (
    // --- KEY CHANGE HERE ---
    // The margin (`mb-4`) has been removed from the component's root div.
    // The parent form now controls all spacing.
    <div className="w-full">
      <label htmlFor={id} className="block text-sm font-medium text-gray-700 mb-1">
        {label}
      </label>
      <input
        id={id}
        type={type}
        className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 ${
          error ? "border-red-500" : "border-gray-300"
        }`}
        {...register(id, { required })}
        {...props}
      />
      {/* Give the error message a fixed height to prevent layout shifts */}
      <div className="h-5"> 
        {error && <p className="text-red-500 text-xs mt-1">{error.message}</p>}
      </div>
    </div>
  );
}

Input.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  type: PropTypes.string,
  register: PropTypes.func.isRequired,
  error: PropTypes.object,
  required: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  pattern: PropTypes.object,
};

export default Input;
